import { IRoutePermissions } from '../../types/common';
import { UserCapabilityName } from '../../types/userCapabilityName';

export const mappingsRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.SuperAdmin,
    UserCapabilityName.ViewAccessPolicies,
    UserCapabilityName.ViewInternalAccessPolicies,
  ],
};
